import React from 'react';
import PropTypes from 'prop-types';

import './styles/preview_header.scss';

const labels = {
  from: 'From',
  preheader: 'Preheader',
  replyToEmail: 'Reply to',
  subject: 'Subject'
};

class PreviewHeader extends React.Component {
  static propTypes = {
    deliveryOptions: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired
  }

  static labels = labels

  getFromLine() {
    const parts = [];
    const deliveryOptions = this.props.deliveryOptions;

    if (deliveryOptions.fromEmail || deliveryOptions.fromName) {
      if (deliveryOptions.fromName) {
        parts.push(deliveryOptions.fromName);
      }

      if (deliveryOptions.fromEmail) {
        parts.push(`<${deliveryOptions.fromEmail}>`);
      }
    }

    return parts.join(' ');
  }

  render() {
    const deliveryOptions = this.props.deliveryOptions;
    const lines = [];

    const fromLine = this.getFromLine();
    if (fromLine) {
      lines.push(this.renderLine(labels.from, fromLine));
    }

    if (deliveryOptions.replyToEmail) {
      lines.push(this.renderLine(labels.replyToEmail, deliveryOptions.replyToEmail));
    }

    lines.push(this.renderLine(labels.subject, this.props.message.subject));

    if (deliveryOptions.preheader) {
      lines.push(this.renderLine(labels.preheader, deliveryOptions.preheader));
    }

    return <div className="preview-header">{lines}</div>;
  }

  renderLine(label, value) {
    return (
      <div key={label}>
        <label>{label}:</label>
        {value}
      </div>
    );
  }
}

export default PreviewHeader;
